(function () {
    'use strict';

    angular
        .module('sodDocumentLibrary')
        .factory('action-open-document-library', actionFunc);

    function actionFunc(DialogManager, DocumentLibraryConstant, $templateCache) {
        return function (options) {
            const dialogOptions = angular.merge(
                {},
                {
                    // functionality shouldn't change regardless of view. So we Hardcode the Controller
                    // Otherwise, options can override it.
                    controller: 'DocumentLibraryController',
                    template: $templateCache.get('common/libraries/document-library/document-library-controller-view'),
                    // dialog_options: {
                    //     modalSize: 'large modal-height-restrict-without-footer',
                    //     classes: {
                    //         wrapper: 'form-block'
                    //     },
                    //     title: "Select Files",
                    //     "upload": {
                    //         "config": {
                    //             "multiple": true,
                    //             "showFileList": false,
                    //             "localization": {
                    //                 "select": "Upload a file",
                    //                 "dropFilesHere": "or drop files here"
                    //             }
                    //         },
                    //         "attr": {
                    //             "sender_name": "file_element"
                    //         },
                    //         "async": {
                    //             "autoUpload": true,
                    //             "batch": false,
                    //             "saveField": "file_element"
                    //         }
                    //     },
                    //     "list": {
                    //         "autoBind": true,
                    //         "noRecords": "<div class=\"list-filter-no-records\">\n    <div>\n        <img src=\"https://content.recruiterpal.com/app/assets/images/common/No_Result_Empty_State.svg\" />\n    </div>\n    <h2>No Documents Yet?</h2>\n    <div>Add a document to get started</div>\n</div>"
                    //     },
                    //     "labels": {
                    //         "uploading": {
                    //             "template": "<i class=\"fa fa-cloud-upload\"></i> Uploading - <name>"
                    //         },
                    //         "uploaded": {
                    //             "template": "<i class=\"fa fa-check success\"></i> Uploaded - <name>"
                    //         },
                    //         "removing": {
                    //             "template": "<i class=\"fa fa-trash\"></i> Removing - <name>"
                    //         },
                    //         "removed": {
                    //             "template": "<i class=\"fa fa-trash success\"></i> Removed - <name>"
                    //         }
                    //     },
                    //     "datasources": {
                    //         "query": {
                    //             "url": "api/v1/rms/document-folders/:folderId",
                    //             "method": "get"
                    //         },
                    //         "remove": {
                    //             "url": "api/v1/rms/documents/%3Cid%3E",
                    //             "method": "delete"
                    //         },
                    //         "update": {
                    //             "url": "api/v1/rms/documents/%3Cid%3E",
                    //             "method": "update"
                    //         },
                    //         "massRemove": {
                    //             "url": "api/v1/rms/documents/deactivate",
                    //             "method": "update"
                    //         },
                    //         "store": {
                    //             "route": "/api/upload/v1/rms/documents"
                    //         }
                    //     },
                    //     // "initialFolderId": "165d5aa21b164f45d254c9aa56289552124d"
                    // }
                },
                // {
                //     // test data. to remove
                //     dialog_options: {
                //         datasources: {
                //             query: {
                //                 url: '/api/v1/rms/document-folders'
                //             },
                //             remove: {
                //                 url: '/api/v1/rms/document-folders/<id>',
                //                 method: 'delete'
                //             },
                //             update: {
                //                 url: '/api/v1/rms/document-folders/<id>',
                //                 method: 'put'
                //             },
                //             massRemove: {
                //                 url: '/api/v1/rms/document-folders/',
                //                 method: 'put'
                //             }
                //         }
                //     }
                // },
                options
            );

            console.log('check upload stuff', dialogOptions);

            return DialogManager.init(DocumentLibraryConstant.DOCUMENT_LIBRARY_DIALOG_IDENTIFIER, dialogOptions);
        };
    }
})();

